import React from 'react';
import type { InputNode } from '../types';

type DebugNodeProps = {
  node: InputNode;
  value: string | string[] | undefined;
  onChange: (key: string, value: string | string[]) => void;
  index?: number;
};

export const DebugNode: React.FC<DebugNodeProps> = ({ node, value, onChange, index }) => {
  const testId = node.key ? `debug-node-${node.key}` : `debug-node-text-${index ?? 0}`;
  if (node.type === 'text' || node.type === 'tag') {
    return <span data-testid={testId} className="rte-text">{node.text}</span>;
  }
  return (
    <input
      data-testid={testId}
      data-value={Array.isArray(value) ? value.join(',') : (value ?? '')}
      value={Array.isArray(value) ? value.join(',') : (value ?? '')}
      onChange={(e) => onChange(node.key!, e.target.value)}
      placeholder={`[${node.type}] ${node.placeholder ?? node.key ?? ''}`}
    />
  );
};
